module.exports = __webpack_public_path__ + "static/media/electron-to-go-logo-ja.4bb9ef98.svg";